const CAP23 = {
  "id": 46,
  "title": "Cómo conseguir Bitcoin con efectivo",
  "slug": "como-conseguir-bitcoin-con-efectivo",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción: de efectivo a Bitcoin",
      "text": [
        "Si quieres conseguir tus primeros bitcoin usando efectivo, lo primero que necesitas es un monedero Bitcoin (wallet).",
        "La función del monedero es muy simple: te da una dirección donde recibir tus bitcoins, te permite ver tu saldo y el historial de transacciones, y te permite enviar fondos cuando lo necesites.",
        "Una vez que tienes tu wallet lista con una dirección de recepción, puedes cambiar dinero en efectivo por Bitcoin a través de diferentes métodos: cajeros Bitcoin, compras P2P (persona a persona), tiendas físicas o vales y tarjetas prepago."
      ]
    },
    {
      "heading": "¿Qué necesitas antes de comprar Bitcoin con efectivo?",
      "list": [
        "Un monedero Bitcoin (wallet) instalado o creado en tu móvil, computadora o en la nube.",
        "Tu dirección pública de recepción (o el código QR que la representa).",
        "Dinero en efectivo en tu moneda local.",
        "Conocer el método que vas a usar: cajero Bitcoin, intercambio P2P, tienda física, etc."
      ]
    },
    {
      "heading": "Opciones principales para conseguir Bitcoin con efectivo",
      "text": [
        "Existen varias formas de convertir efectivo en Bitcoin. Las más comunes son:"
      ],
      "list": [
        "Cajeros automáticos Bitcoin (Bitcoin ATM) que aceptan billetes.",
        "Plataformas P2P donde compras Bitcoin a otras personas pagando en efectivo.",
        "Tiendas físicas o puntos de venta que aceptan efectivo y te envían Bitcoin a tu dirección.",
        "Vales, tarjetas prepago o códigos que se compran en efectivo y luego se canjean por Bitcoin."
      ]
    },
    {
      "heading": "Comprar Bitcoin con efectivo en un cajero Bitcoin (ATM)",
      "text": [
        "1. Localiza un cajero Bitcoin cercano que acepte efectivo.",
        "2. En la pantalla, selecciona la opción de comprar Bitcoin.",
        "3. Introduce la cantidad que quieres comprar o los billetes en efectivo.",
        "4. El cajero te pedirá una dirección de recepción: puedes escanear tu código QR del monedero.",
        "5. Confirma la operación.",
        "6. El cajero enviará los Bitcoin a tu dirección y recibirás un comprobante. Los fondos aparecerán en tu wallet después de que la transacción sea procesada por la red."
      ]
    },
    {
      "heading": "Comprar Bitcoin con efectivo usando plataformas P2P",
      "text": [
        "Otra forma de conseguir Bitcoin con efectivo es comprarlo directamente a otras personas mediante plataformas P2P (persona a persona).",
        "En este caso, la plataforma funciona como intermediaria, mostrando vendedores que aceptan pagos en efectivo."
      ],
      "list": [
        "1. Crear tu cuenta en una plataforma P2P confiable.",
        "2. Buscar ofertas de vendedores que acepten efectivo como método de pago.",
        "3. Acordar el monto y la forma de entrega (depósito en efectivo, reunión en lugar público, etc.).",
        "4. Enviar tu dirección Bitcoin al vendedor a través del sistema seguro de la plataforma.",
        "5. Una vez que el vendedor confirma haber recibido el efectivo, libera los Bitcoin y estos llegan a tu monedero."
      ]
    },
    {
      "heading": "Tiendas físicas, corresponsales y vales",
      "text": [
        "En algunos países, existen tiendas físicas, kioscos o corresponsales donde puedes entregar efectivo y recibir Bitcoin.",
        "También existen vales o tarjetas prepago que compras en efectivo y luego canjeas en una web o app introduciendo el código.",
        "En todos los casos, el resultado es el mismo: los Bitcoin se envían a la dirección de tu monedero."
      ]
    },
    {
      "heading": "Relación con el monedero: dónde se guardan tus Bitcoin",
      "text": [
        "Cuando compras Bitcoin con efectivo, los fondos no se guardan físicamente dentro del teléfono ni dentro de la app.",
        "Lo que hace el monedero es gestionar tus claves privadas y públicas y mostrarte el saldo que la blockchain registra a favor de tus direcciones.",
        "Tu wallet es la herramienta que te permite recibir, ver y gastar los Bitcoin que conseguiste con efectivo."
      ]
    },
    {
      "heading": "Seguridad básica al usar efectivo",
      "list": [
        "Utiliza solo cajeros, tiendas y plataformas P2P confiables.",
        "En operaciones cara a cara, elige lugares públicos y seguros.",
        "Nunca compartas tu clave privada ni tu frase semilla (seed phrase).",
        "Solo comparte tu dirección pública o su código QR para recibir pagos.",
        "Verifica siempre la cantidad y la dirección antes de confirmar la operación."
      ]
    },
    {
      "heading": "Resumen",
      "list": [
        "Puedes convertir efectivo en Bitcoin usando cajeros Bitcoin, plataformas P2P, tiendas físicas o vales.",
        "Siempre necesitarás un monedero Bitcoin para recibir tus fondos.",
        "El efectivo se transforma en Bitcoin que quedan registrados en la blockchain y visibles desde tu wallet.",
        "La seguridad depende de usar servicios confiables y proteger correctamente tus claves privadas."
      ]
    }
  ]
};

export default CAP23;
